export default function Refund() {
  const style = `
    @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,wght@0,900;1,900&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: 'Plus Jakarta Sans', sans-serif; background: #FAF7F2; color: #1E1040; }
    .legal-nav { background: #fff; border-bottom: 1px solid #EDE9E3; padding: 16px 48px; display: flex; align-items: center; justify-content: space-between; }
    .legal-logo { font-family: 'Fraunces', serif; font-weight: 900; font-size: 22px; color: #1E1040; text-decoration: none; }
    .legal-logo span { color: #8B5CF6; font-style: italic; }
    .legal-wrap { max-width: 760px; margin: 0 auto; padding: 60px 48px; }
    .legal-eyebrow { font-size: 11px; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; color: #8B5CF6; margin-bottom: 12px; }
    .legal-title { font-family: 'Fraunces', serif; font-weight: 900; font-size: 42px; color: #1E1040; margin-bottom: 8px; line-height: 1.1; }
    .legal-date { font-size: 13px; color: #9CA3AF; margin-bottom: 48px; }
    .legal-intro { font-size: 16px; color: #374151; line-height: 1.8; margin-bottom: 40px; padding: 24px; background: rgba(139,92,246,0.04); border: 1px solid rgba(139,92,246,0.1); border-radius: 14px; }
    .legal-guarantee { background: linear-gradient(135deg, rgba(139,92,246,0.06), rgba(56,189,248,0.04)); border: 1.5px solid rgba(139,92,246,0.2); border-radius: 16px; padding: 28px 32px; margin-bottom: 40px; text-align: center; }
    .legal-guarantee-title { font-family: 'Fraunces', serif; font-weight: 900; font-size: 28px; color: #1E1040; margin-bottom: 8px; }
    .legal-guarantee-sub { font-size: 15px; color: #6B7280; line-height: 1.6; }
    .legal-section { margin-bottom: 36px; }
    .legal-section h2 { font-family: 'Fraunces', serif; font-weight: 900; font-size: 22px; color: #1E1040; margin-bottom: 14px; }
    .legal-section p { font-size: 15px; color: #374151; line-height: 1.8; margin-bottom: 12px; }
    .legal-section ul { list-style: none; margin: 0 0 12px 0; display: flex; flex-direction: column; gap: 8px; }
    .legal-section ul li { font-size: 15px; color: #374151; line-height: 1.6; padding-left: 20px; position: relative; }
    .legal-section ul li::before { content: '·'; position: absolute; left: 0; color: #8B5CF6; font-weight: 700; }
    .legal-section a { color: #8B5CF6; text-decoration: none; }
    .legal-section a:hover { text-decoration: underline; }
    .legal-footer { margin-top: 60px; padding-top: 32px; border-top: 1px solid #EDE9E3; display: flex; gap: 24px; flex-wrap: wrap; }
    .legal-footer a { font-size: 13px; color: #9CA3AF; text-decoration: none; transition: color 0.2s; }
    .legal-footer a:hover { color: #8B5CF6; }
    @media(max-width:640px){ .legal-wrap { padding: 40px 24px; } .legal-nav { padding: 16px 24px; } }
  `;

  return (
    <>
      <style>{style}</style>
      <nav className="legal-nav">
        <a href="/" className="legal-logo">Merq<span>Legacy</span></a>
        <a href="mailto:hello@getmerq.com" style={{fontSize:13,color:'#9CA3AF',textDecoration:'none'}}>hello@getmerq.com</a>
      </nav>
      <div className="legal-wrap">
        <div className="legal-eyebrow">Legal</div>
        <h1 className="legal-title">Refund Policy</h1>
        <div className="legal-date">Last updated: April 10, 2026</div>

        <div className="legal-guarantee">
          <div className="legal-guarantee-title">🛡️ 30-Day Money-Back Guarantee</div>
          <div className="legal-guarantee-sub">If you're not satisfied within your first 30 days, email us and we'll refund you in full — no questions asked.</div>
        </div>

        <div className="legal-section">
          <h2>Our Guarantee</h2>
          <p>We stand behind Merq Legacy completely. If you subscribe and are not satisfied for any reason within the first 30 days of your paid subscription, contact us at <a href="mailto:hello@getmerq.com">hello@getmerq.com</a> and we will issue a full refund — no questions asked, no hoops to jump through.</p>
        </div>

        <div className="legal-section">
          <h2>Annual Subscriptions</h2>
          <ul>
            <li>Full refund within the first 30 days — guaranteed, no questions asked</li>
            <li>After 30 days, we do not offer prorated refunds for the remaining months</li>
            <li>Your access continues until the end of your current billing period after cancellation</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>How to Request a Refund</h2>
          <p>Email us at <a href="mailto:hello@getmerq.com">hello@getmerq.com</a> with:</p>
          <ul>
            <li>Subject line: "Refund Request"</li>
            <li>The email address associated with your account</li>
            <li>That's it — we'll take care of the rest</li>
          </ul>
          <p>We process eligible refunds within 5–7 business days. Refunds are issued to the original payment method.</p>
        </div>

        <div className="legal-section">
          <h2>Exceptions</h2>
          <p>Refunds will not be issued in cases of account termination due to violation of our <a href="/terms">Terms of Service</a>.</p>
        </div>

        <div className="legal-section">
          <h2>Contact Us</h2>
          <p>Questions? We're real people and we'll respond promptly.</p>
          <p><a href="mailto:hello@getmerq.com">hello@getmerq.com</a><br />Merq Software · Texas, United States</p>
        </div>

        <div className="legal-footer">
          <a href="/">Home</a>
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
          <a href="/refund">Refund Policy</a>
          <a href="mailto:hello@getmerq.com">Contact</a>
        </div>
      </div>
    </>
  );
}
